import { ExternalLink as ExtIcon } from "lucide-react";
import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  LinkButton,
  Card,
} from "../../components/ui";
import { Seo } from "../../lib/head";

export function Status() {
  return (
    <>
      <Seo title="Status — WeConsult Rx" description="WeConsult Rx system status and incident history." path="/status" />
    <Section>
      <Container>
        <div className="max-w-3xl">
          <Eyebrow>Status</Eyebrow>
          <Heading level={1} className="mt-3">
            System status
          </Heading>
          <Lede className="mt-6">
            We publish realtime uptime and incident history on our dedicated
            status portal. Subscribe there for email or SMS alerts.
          </Lede>
          <div className="mt-8 flex flex-wrap gap-3">
            <LinkButton href="https://status.weconsultrx.com" target="_blank" rel="noopener noreferrer">
              Visit status portal
              <ExtIcon className="h-4 w-4" aria-hidden />
            </LinkButton>
            <LinkButton to="/sla" variant="secondary">
              View SLA
            </LinkButton>
          </div>
        </div>

        <Card className="mt-12 max-w-3xl">
          <p className="text-sm text-ink-500">
            <strong>Note:</strong> the status portal at{" "}
            <code>status.weconsultrx.com</code> is hosted separately so it
            remains reachable during platform incidents.
          </p>
        </Card>
      </Container>
    </Section>
    </>
  );
}
